import Util from '../util';

/*
  NEW: filename template resolver (docs/todo/preview-view-conditions.md) - 'shirt_{option1}' resolves against
  live variant/option values and is matched against media basenames (layer media match + gallery media groups)
*/
class MediaUtil {

    // lowercase, trim, spaces / - / "/" folded to _ ("Red / XL" -> red_xl) - applied to BOTH sides of a match
    static normalize(value){
        return value.toString().toLowerCase().trim().replace(/[\s/-]+/g, '_');
    }

    // resolved basename to match or null if a placeholder has no value yet (caller falls through)
    static resolve(template, variant, options){
        let unresolved = false;

        // strip a tolerated authored extension (shirt_{option1}.png) BEFORE interpolation
        let resolved = template.replace(/\.[a-z0-9]+$/i, '').replace(/\{([^}]+)\}/g, (match, name) => {
            let value = this._getValue(name.trim().toLowerCase(), variant, options);

            if(value == null || value === ''){
                unresolved = true;
                return '';
            }

            return value.toString();
        });

        return unresolved ? null : this.normalize(resolved);
    }

    // {option1-3}/{title} from the current variant - {options.Name} from an app option (case-insensitive)
    static _getValue(name, variant, options){
        if(name.indexOf('options.') === 0){
            let option = options ? this._findOption(name.substring(8).trim(), options) : null;

            if(option){
                // dynamic value from controller (same hook as ConditionsEngine)
                if(option._controller && typeof option._controller.conditionValue === 'function'){
                    return option._controller.conditionValue(option);
                }
                return option.value;
            }

            return null;
        }

        return variant ? variant[name] : null;
    }

    static _findOption(name, options){
        for (let i = 0; i < options.length; i++) {
            const option = options[i];

            if(option.name && option.name.toLowerCase() === name){
                return option;
            }
            // nested options (groups)
            if(option.options && option.options.length){
                let nested = this._findOption(name, option.options);
                if(nested){
                    return nested;
                }
            }
        }

        return null;
    }

    static findVariant(product, variantId){
        if(product && variantId){
            for (let i = 0; i < product.variants.length; i++) {
                const variant = product.variants[i];
                if(variant.id.toString() === variantId.toString()){
                    return variant;
                }
            }
        }

        return null;
    }

    // pick ONE image: exact basename wins over token-boundary prefix (shirt_red vs shirt_red_dark) -
    // the prefix fallback covers Shopify re-upload suffixes (shirt_red_2)
    static findImage(images, resolved){
        let prefixMatch = null;

        for (let i = 0; i < images.length; i++) {
            let src = images[i].src || images[i]; // string (page JS) or {src} (REST)
            let baseName = this.normalize(Util.pathBaseName(src, false));

            if(baseName === resolved){
                return src;
            }
            if(!prefixMatch && baseName.indexOf(resolved + '_') === 0){
                prefixMatch = src;
            }
        }

        return prefixMatch;
    }

}

export default MediaUtil;
